import { InputWithOptionsDriver } from '../InputWithOptions/InputWithOptions.driver';

export interface DropdownDriver extends InputWithOptionsDriver {}
